export const ALTER_CONFIRM_ALERT = "ALTER_CONFIRM_ALERT";
export const ALTER_CONFIRM_ALERT_CUSTOM_PARAMETERS = "ALTER_CONFIRM_ALERT_CUSTOM_PARAMETERS";
export const HIDE_CONFIRM_ALERT = "HIDE_CONFIRM_ALERT";


export const alertConfirmAlertAction = data => ({
	type: ALTER_CONFIRM_ALERT,
	payload: data
});

export const alertConfirmActionWithCustomParameters = data => ({
	type: ALTER_CONFIRM_ALERT_CUSTOM_PARAMETERS,
	payload: data
});

export const hideConfirmAlertAction = () => ({
	type: HIDE_CONFIRM_ALERT
});
